import React from "react";
import { isViewVisible } from "../../../utils/ViewSettings";
import ContingentsView from "./components/ContingentsView";
import Rbac from "../../../utils/Rbac";
import ContingentsControllerAccessBarMap from "../../../controllers/ContingentsControllerAccessBarMap";
import t from "../../helpers/t";
import Inboomasubmenu from "../../components/InboomaSubmenu";
import { createSubmenuItems } from "../../../utils/Helper";

export const rbac = new Rbac({
  _rbac: {
    admin: {
      write: true,
      editContingent: true,
      configureResource: true,
      editPrice: true,
      deleteContingent: true,
    },
    manager: {
      write: true,
      editContingent: true,
      configureResource: true,
      editPrice: false,
      deleteContingent: false,
    },
    "manager-location": {
      write: false,
      editContingent: false,
      configureResource: true,
      editPrice: false,
      deleteContingent: false,
    },
    user: {
      write: false,
      editContingent: false,
      configureResource: false,
      editPrice: false,
      deleteContingent: false,
    },
    "garage-staff": {
      write: false,
      editContingent: false,
      configureResource: false,
      editPrice: false,
      deleteContingent: false,
    },
  },
});

export const ContingentsPage = (props) => {
  let _view = typeof props.view === "undefined" || props.view === null ? "index" : props.view;
  let indexView = isViewVisible("contingents", "contingents") ? "contingents" : "";

  return (
    <>
      {(_view === "contingents" || (_view === "index" && indexView === "contingents")) && (
        <ContingentsView
          name={"contingents"}
          dispatch={props.dispatch}
          params={props.params}
          returnPath={props.returnPath}
          rbac={rbac}
          submenuitems={createSubmenuItems("contingents")}
          createAccessBar={props.createAccessBar}
        />
      )}
    </>
  );
};
